import { render, staticRenderFns } from "./helpServer.vue?vue&type=template&id=497735d4&scoped=true"
import script from "./helpServer.vue?vue&type=script&lang=js"
export * from "./helpServer.vue?vue&type=script&lang=js"
import style0 from "./helpServer.vue?vue&type=style&index=0&id=497735d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497735d4",
  null
  
)

export default component.exports